import type { FaireProductEntity } from "../../entity_types/product";

export const p_6rbx3jcxxz: FaireProductEntity = {
  token: "p_6rbx3jcxxz",
  type: "product",
  name: "Ribbed Stripe Henley Tee & Shorts Lounge Set",
  brandToken: "b_elccldtdr7",
  brandName: "Urban Daizy",
  imageUrl:
    "https://cdn.faire.com/fastly/c1e607c0ec7c5bf95b361e2e0f1d8ccd3b48c7065fbeb84bdac560b399f742ba.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cec1ee1e187237a534c398bac627785fcf8c5e94fb089682d69e2bd58293e54f.jpeg",
    "https://cdn.faire.com/fastly/d1bdf34596c3772a546945e1c122129a11f5ccf3ac0ef7f83df86bc87c3f8731.jpeg",
    "https://cdn.faire.com/fastly/1189979641e05627906dfcbfab4df59a0932008e5de9af2c596ab31f54dd6fdb.jpeg",
    "https://cdn.faire.com/fastly/0dd8f192486420d7cad5991027046e441913e6b5094a28ef8dd15bc7c699bbce.jpeg",
    "https://cdn.faire.com/fastly/b8cfb27789d1a04040ba8afdda810bc8996ff193dc946a776fa880116d94a39f.jpeg",
    "https://cdn.faire.com/fastly/9ec1e52ce603226860a2afcbe808e7aa339996204f32aedab2575c3e1d2becc7.jpeg",
    "https://cdn.faire.com/fastly/3a050b66175dccfc1cf371fb2453399adb75ae6e85432a47f24c24e93a29aab4.jpeg",
    "https://cdn.faire.com/fastly/6cd99c10eac95b4e2543d7b507ba28394928e2446ea5ad0e12e527e60bf947ef.jpeg",
    "https://cdn.faire.com/fastly/8b33024577866c9004f6e89fcf1843bb27b97404fdb18b4f61731fc5a0168938.jpeg",
    "https://cdn.faire.com/fastly/6ffc69720dfc9205340abf4f177cef586509226ae597b6453c92326d154a116e.jpeg",
    "https://cdn.faire.com/fastly/47574c53ced178c6bc84ec73b0c0cc6f45893fde14b45b25dc27628d9fce7a40.jpeg",
    "https://cdn.faire.com/fastly/82ae235c150725dd9ccd966452ccb2f1551c1e38969b9281e2734bb4f50321ad.jpeg",
    "https://cdn.faire.com/fastly/4418886efbc96d5cba2b4a68a27eaef2cd95f5d28952a8ed5e09eee934064996.jpeg",
    "https://cdn.faire.com/fastly/2095daf25fc6003cffc6e24aef53a7fca34d5ab80f2d99934b84e59bb8d5c5db.jpeg",
    "https://cdn.faire.com/fastly/ec4f6fd9c91bd4e1a89510b65ecf18706875fe67071ca31ce0fcad2f1fa13885.jpeg",
    "https://cdn.faire.com/fastly/1467da91c58a383961a8d0eee5eed15f86bcb19b9cd1821f6e8724732872c310.jpeg",
    "https://cdn.faire.com/fastly/c3acec6b002b53fb8fb211c09cc7f9aad8ea9a9196170ba92c9d86cad4a87f0d.jpeg",
    "https://cdn.faire.com/fastly/0bcc67b259bced680f175d84211547a992c04bd6590d8a013ab05308cd6f22ed.jpeg",
    "https://cdn.faire.com/fastly/bd8365e21ba1e1faaa8ff6c42cb8606b2cea0e69fb283018670156fb1353fcc8.jpeg",
    "https://cdn.faire.com/fastly/96adfc4a14c10c56754fee56d65f3cb65a2e9d48842b032d6b532a5f38293039.jpeg",
    "https://cdn.faire.com/fastly/0cd36a8922fdb79da3416033dac086f4a9374d6f0a2fe742e784fe88287ccf92.jpeg",
    "https://cdn.faire.com/fastly/b8a471fd994d937a6e385ea31a07aaa97419f5b115a6a80117f28beaea7c9e34.jpeg",
    "https://cdn.faire.com/fastly/c9e479c7cf92a16b0a621b1d095a90c34c55ad3574a5e6221746a449f8e63451.jpeg",
    "https://cdn.faire.com/fastly/22ad99fad6059ee7848c4cabf88e75a0ee84c2b22fe1ab906153d33997b781a1.jpeg",
    "https://cdn.faire.com/fastly/b1bedb54e288a82c5b7a083703ef8daa85d721f943deecbf6998ac4875505c3d.jpeg",
    "https://cdn.faire.com/fastly/c7d4a09bcbf96ab15e539ad93fec4a9eed9a4eee995a285dcbf2cc45f092c430.jpeg",
  ],
  priceDollars: 32.99,
  description:
    "Design/Fit: This set features a relaxed, easy silhouette with a classic four-button henley placket and short sleeves with cuffed trim. The top is finished with a flattering curved hemline, while the matching shorts offer a comfortable elasticated waistband for effortless wear.\n\nFabric/Texture: Crafted from a soft, lightweight ribbed fabric that provides a gentle stretch and a high-quality hand-feel.\n\nKey Features: Contrast solid-tone trim at the neckline and sleeves adds a refined touch, complementing the classic horizontal stripes.\n\nSpecs: * Sizing Pack: S-M-L (2-2-2 ratio)\n\nOrigin: Made in China",
  tags: [],
  msrpDollars: 65.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:30.101Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
